import { Component } from '@angular/core';
import { NavController, NavParams ,ViewController} from 'ionic-angular';
import { SelectionSearchService } from '../../services/selection-search' ;
import {GVLogger} from "../../services/gv-logger";


@Component({
  selector: 'page-selection-search',
  templateUrl: 'selection-search.html'
})
export class SelectionSearchPage {

	searchQuery: string = '';
  	items=[];

  constructor(public navCtrl: NavController, public navParams: NavParams ,
  	public ss:SelectionSearchService,public viewController:ViewController, private gVLogger: GVLogger) {

  	this.gVLogger.log(this.ss.getItemsList());
	    this.items = this.ss.getItemsList();
  }

  ionViewDidLoad() {
    this.gVLogger.log('ionViewDidLoad SelectionSearchPage');
  }

	initializeItems() {
	    this.items = this.ss.getItemsList();
	   //  this.items = [
    //   'Amsterdam',
    //   'Bogota'

    // ];
	  }

  getItems(ev: any) {
    // Reset items back to all of the items
    this.initializeItems();

    // set val to the value of the searchbar
    let val = ev.target.value;

    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.items = this.items.filter((item) => {
        return (item.desctiption.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }
  }

  itemClick(item){

  	if(this.ss.getVarableType() == "countries1"){
  		this.ss.setCountry1(item.code);
  	}else if(this.ss.getVarableType() == "state1"){
		this.ss.setState1(item.code);
  	}else if(this.ss.getVarableType() == "city1"){
  		this.ss.setCity1(item.code);
  	}else if(this.ss.getVarableType() == "countries2"){
  		this.ss.setCountry2(item.code);
  	}else if(this.ss.getVarableType() == "state2"){
  		this.ss.setState2(item.code);
  	}else if(this.ss.getVarableType() == "city2"){
  		this.ss.setCity2(item.code);
  	}

  	let data = { viewType:this.ss.getVarableType() , item:item};

  	this.viewController.dismiss(data);
  	this.gVLogger.log(item);
  }

}



// WEBPACK FOOTER //
// ./src/pages/selection-search/selection-search.ts